<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="modal-container" @click.stop>
                    <div class="kuli-modal-header">
                        <h2>{{ isNew ? 'Tambah' : 'Edit' }} Kuli</h2>
                        <button class="kuli-close" type="button" @click="$emit('closeModal')">
                            <i class="fal fa-times"></i>
                        </button>
                        <p class="kuli-required-note">
                            <span>*</span> is a required field
                        </p>
                    </div>

                    <div class="kuli-modal-body">
                        <div class="kuli-form-row">
                            <label><span>*</span>Nama Kuli:</label>
                            <input v-model="form.name" type="text" placeholder="Masukkan nama lengkap" :disabled="loadingDetail">
                        </div>

                        <div v-if="!isNew" class="kuli-form-row">
                            <label>Status</label>
                            <select v-model="form.status" :disabled="loadingDetail">
                                <option value="ACTIVE">ACTIVE</option>
                                <option value="INACTIVE">INACTIVE</option>
                            </select>
                        </div>

                        <div class="kuli-modal-actions">
                            <button class="kuli-button-outline" type="button" @click="$emit('closeModal')">Cancel</button>
                            <button class="kuli-button-primary" type="button" @click="submitForm" :disabled="loadingDetail">
                                {{ isNew ? 'Tambah' : 'Edit' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {
            isNew: true,
            form: {
                id: null,
                name: '',
                status: 'ACTIVE'
            },
            loadingDetail: false
        }
    },
    mounted() {
        if (this.data) this.convertEdit()
    },
    methods: {
        convertEdit() {
            this.isNew = false
            this.form.id = this.data.id
            this.form.name = this.data.name
            this.form.status = this.isActive(this.data.status) ? 'ACTIVE' : 'INACTIVE'
            this.getKuliDetail()
        },
        getKuliDetail() {
            if (!this.form.id) return

            this.loadingDetail = true
            this.$http.get(`/api/settings/get-kuli-detail?id=${this.form.id}`)
                .then((resp) => {
                    const detail = Array.isArray(resp.data.data) ? resp.data.data[0] : resp.data.data
                    if (!detail) return

                    this.form.id = detail.id
                    this.form.name = detail.name
                    this.form.status = this.isActive(detail.status) ? 'ACTIVE' : 'INACTIVE'
                })
                .catch((err) => {
                    const data = err.response ? err.response.data : null
                    this.$swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        type: 'error',
                        text: data && data.message ? data.message : 'Gagal mengambil detail kuli'
                    })
                    this.$emit('closeModal')
                })
                .finally(() => {
                    this.loadingDetail = false
                })
        },
        isActive(status) {
            return status === 1 || status === '1' || status === true || status === 'ACTIVE'
        },
        validateForm() {
            if (!this.form.name) {
                return false
            }

            return true
        },
        submitForm() {
            if (!this.validateForm()) return

            const payload = {
                name: this.form.name.trim()
            }

            const method = this.isNew ? 'post' : 'put'
            const url = this.isNew ? '/api/settings/add-kuli' : `/api/settings/update-kuli/${this.form.id}`

            if (!this.isNew) payload.status = this.form.status

            this.$http[method](url, payload)
                .then(() => {
                    this.$swal.fire({
                        title: this.isNew ? 'Berhasil Menambahkan Kuli' : 'Berhasil Mengubah Kuli',
                        icon: 'success',
                        type: 'success',
                        confirmButtonColor: '#1B698E'
                    })

                    this.$emit('refreshData')
                    this.$emit('closeModal')
                })
                .catch((err) => {
                    const data = err.response ? err.response.data : null
                    this.$swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        type: 'error',
                        text: data && data.message ? data.message : 'Gagal menyimpan kuli'
                    })
                })
        }
    }
}
</script>

<style scoped>
.modal-mask {
    background-color: rgba(0, 0, 0, .5);
    display: table;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    transition: opacity .3s ease;
    width: 100%;
    z-index: 1020;
}

.modal-wrapper {
    display: table-cell;
    padding: 16px;
    vertical-align: middle;
}

.modal-container {
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    font-family: Poppins, sans-serif;
    margin: 0 auto;
    max-width: 800px;
    transition: all .3s ease;
    width: 100%;
}

.kuli-modal-header {
    align-items: center;
    display: grid;
    grid-template-columns: 56px 1fr 56px;
    min-height: 108px;
    padding: 22px 36px 10px;
    position: relative;
    text-align: center;
}

.kuli-modal-header h2 {
    color: #343434;
    font: normal normal normal 28px/42px Poppins;
    grid-column: 2;
    margin: 0;
}

.kuli-close {
    background: transparent;
    border: 0;
    color: #343434;
    font-size: 28px;
    grid-column: 3;
    height: 40px;
    justify-self: end;
    line-height: 1;
    padding: 0;
    width: 40px;
}

.kuli-required-note {
    color: #FF0000;
    font: normal normal normal 14px/21px Poppins;
    grid-column: 1 / -1;
    margin: 16px 0 0;
}

.kuli-required-note span,
.kuli-form-row label span {
    color: #FF0000;
}

.kuli-modal-body {
    border-top: 1px solid #D8D8D8;
    padding: 28px 48px 36px;
}

.kuli-form-row {
    display: grid;
    gap: 36px;
    grid-template-columns: 206px 1fr;
    margin-bottom: 26px;
}

.kuli-form-row label {
    color: #343434;
    font: normal normal normal 18px/27px Poppins;
    margin: 11px 0 0;
    text-align: left;
}

.kuli-form-row input,
.kuli-form-row select {
    border: 1px solid #D8D8D8;
    border-radius: 6px;
    color: #343434;
    font: normal normal normal 18px/27px Poppins;
    height: 51px;
    padding: 8px 12px;
}

.kuli-form-row input::placeholder {
    color: #B6B6B6;
}

.kuli-modal-actions {
    display: grid;
    gap: 294px;
    grid-template-columns: 1fr 1fr;
    margin-top: 32px;
}

.kuli-button-outline,
.kuli-button-primary {
    border-radius: 6px;
    font: normal normal normal 22px/33px Poppins;
    height: 60px;
}

.kuli-button-outline {
    background: #FFFFFF;
    border: 1px solid #1B698E;
    color: #1B698E;
}

.kuli-button-primary {
    background: #1B698E;
    border: 1px solid #1B698E;
    color: #FFFFFF;
}

.modal-enter,
.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    transform: scale(1.1);
}

@media (max-width: 576px) {
    .kuli-form-row {
        grid-template-columns: 1fr;
    }

    .kuli-modal-actions {
        gap: 16px;
    }
}
</style>
